module.exports = __webpack_public_path__ + "img/bio-craig-myers.543f4d85.png";